interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
  color: string;
  bgColor: string;
  borderColor: string;
  trend?: string;
  trendUp?: boolean;
}

export default function StatCard({ label, value, icon, color, bgColor, borderColor, trend, trendUp }: StatCardProps) {
  return (
    <div className={`bg-white rounded-2xl border-2 ${borderColor} p-5 flex flex-col gap-3 transition-all duration-200 hover:scale-[1.02]`}>
      <div className="flex items-center justify-between">
        <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${bgColor}`}>
          <i className={`${icon} text-xl ${color}`}></i>
        </div>
        {trend && (
          <span className={`text-xs font-semibold px-2 py-1 rounded-full ${trendUp ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-500'}`}>
            {trendUp ? '↑' : '↓'} {trend}
          </span>
        )}
      </div>
      <div>
        <p className="text-2xl font-bold text-gray-800">{value}</p>
        <p className="text-sm text-gray-500 mt-0.5">{label}</p>
      </div>
    </div>
  );
}
